import Douglas from '../images/douglas.jpeg';

export const currentUser = {
  name: 'Douglas Augustine',
  image: Douglas,
};

export const memories = [
  {
    title: 'Cross-country road trip',
    body: 'Have you ever driven across the country? Neither have I, until one day I convinced my sister \
    to complete this bucket-list adventure with me. We started in California and first drove to Phoenix, \
    Arizona. We passed through Los Angeles on our way. In Phoenix, we rented an AirBnb townhouse for our 3 days there. \
    One of those days, we would venture to see the Grand Canyon. It was amazing! Located in Arizona,\
     Grand Canyon National Park encompasses 277 miles (446 km) of the Colorado River and adjacent uplands.\
      The immense Grand Canyon is a mile (1.6 km) deep, and up to 18 miles (29 km) wide. \
      Layered bands of colorful rock reveal millions of years of geologic history with unmatched vistas from the rim.\
       The South Rim is open 24 hours. The North Rim is Closed for the Winter.',
    featuredImage:
      'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-1.2.\
      1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1642&q=80',
    visibility: 'Public',
    created: 1649963332,
    collections: ['Travel', 'Family'],
    tags: ['blah', 'blahblah'],
    user: {
      firstName: 'Adrienne',
      lastName: 'Britton',
      thumbnail:
        'https://images.unsplash.com/photo-1595085610896-fb31cfd5d4b7?ixlib=rb-1.2.\
        1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2067&q=80',
    },
  },
  {
    title: 'What is a fond childhood memory?',
    body: 'Going to the candy shop is always a vivid part of my childhood. I would go every Sunday afternoon with \
    my best friends. Our candy shop has so many different types of candies, from all over the world too! My favorite\
     thing is how they had a mini theater that would play Willy Wonka and the Chocolate Factory nonstop. I would always\
      buy my candy choice of the week and then watch for a bit. Everyone has an extremely vivid and pleasant memory of \
      where they went as a child to get their favorite candy - whether it was the corner store or their Grandma\'s \
      candy dish. Powell\'s Sweet Shoppes are a nostalgic re-creation of that classic and bygone era. On the surface \
      we sell ice cream and sweets, but you don\'t have to stand in the Shoppe too long before you realize that what\
       we really offer are memories. \'I feel like a kid in a candy store!\' and \'I haven\'t seen that since I was \
       a kid!\'\' are far and away the most common things we hear. And that is precisely our goal. We want to walk\
        our customers down memory lane and remind them of good things and good times.',
    featuredImage:
      'https://images.unsplash.com/photo-1583440772344-edd2e043742c?ixlib=rb-1.2.1\
      &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
    visibility: 'Private',
    created: 1649963332,
    collections: ['Childhood', 'Silly Things'],
    tags: ['blah', 'blahblah'],
    user: {
      firstName: 'Amir',
      lastName: 'Morales',
      thumbnail:
        'https://images.unsplash.com/photo-1542803293-cde7da05c348?ixlib=rb-1.2.1\
        &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2092&q=80',
    },
  },
  {
    title: 'My favorite foods',
    body: 'This creamy avocado dip is one of my favorite appetizers to make in the spring and early summer.\
     To be clear, it’s not at all like guacamole, the other avocado dip we all know and love. Instead of fresh\
      cilantro and lime juice, dill and lemon create its bright, refreshing flavor. Dijon mustard gives it a\
       tangy kick, and Greek yogurt makes it extra-rich and creamy. Instead of scooping it up with tortilla chips,\
        I recommend pairing it with lots of fresh veg. At this time of year, so many dip-able vegetables are coming\
         into season (radishes, snap peas, etc.). This smooth and silky avocado dip is the perfect way to jazz them \
         up! ',
    featuredImage:
      'https://images.unsplash.com/photo-1650542914727-9e22ac668ef5?ixlib=rb-1.2.1\
      &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
    visibility: 'Public',
    created: 1649963332,
    collections: ['Best Eats', 'Traditions'],
    tags: ['blah', 'blahblah'],
    user: {
      firstName: 'Mike',
      lastName: 'Perry',
      thumbnail:
        'https://images.unsplash.com/photo-1628890920690-9e29d0019b9b?ixlib=rb-1.2.1\
        &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80',
    },
  },
  {
    title: 'New hobby',
    body: 'When you graduated from tricycle to bicycle as a kid, you probably weren’t\
     thinking too much about the health benefits of biking. But as an adult, cycling \
     becomes a great low-impact exercise that can also take you places, wrapping a hobby,\
      exercise, and commute all in one two-wheel package. Whether you’re flying across the\
       pavement through the fresh air or working up a sweat on a stationary bike in your home, \
       there are many benefits of biking 30 minutes a day, so read our list to get in on the perks. \
       Getting your heart rate up doesn’t have to be hard on your joints. Opposed to running or \
       plyometric workouts, cycling gets your cardio done in a low impact way. The pedals and resistance take \
       the pressure off of your knees and hips so you can focus on building muscular strength.',
    featuredImage:
      'https://images.unsplash.com/photo-1651044102572-d22410d88837?ixlib=rb-1.2.1\
      &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
    visibility: 'All Friends',
    created: 1649963332,
    collections: ['Adventures', 'Outdoors'],
    tags: ['blah', 'blahblah'],
    user: {
      firstName: 'Rhonda',
      lastName: 'Smith',
      thumbnail:
        'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1\
        &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80',
    },
  },
  {
    title: 'Monthly dinner get-together',
    body: 'Advance planning will ultimately make a dinner party that much easier to pull off. \
    Making accurate lists and giving yourself plenty of time for each task will minimize chaos and help you \
    tackle the inevitable glitches that arise. The British party planner Fiona Leahy says that as a \
    professional, outsourcing is key for her own busy life, but even if you can’t hire a \
    catering staff for your private affair,think about what you don’t have to do yourself — \
    like picking up a dessert, having wine, flowers or other supplies delivered, or hiring a \
    cleaning service for before or after the party. Keeping it simple for yourself is crucial. ',
    featuredImage:
      'https://images.unsplash.com/photo-1621112904887-419379ce6824?ixlib=rb-1.2.1\
      &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1772&q=80',
    visibility: 'All Friends',
    created: 1649963332,
    collections: ['Memories with Friends'],
    tags: ['blah', 'blahblah'],
    user: {
      firstName: 'Jackie',
      lastName: 'Thompson',
      thumbnail:
        'https://images.unsplash.com/photo-1534180477871-5d6cc81f3920?ixlib=rb-1.2.1\
        &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    },
  },
];
export const prompts = [
  {
    title:
      'Which would you rather do: wash dishes, mow the lawn, clean the bathroom, or vacuum the house?',
    tag: 'unusual experiences',
    to: '#',
  },
  {
    title: 'Who is your hero?',
    tag: 'family',
    to: '#',
  },
  {
    title: 'What is your proudest accomplishment?',
    tag: 'career',
    to: '#',
  },
  {
    title: 'What would you change about yourself if you could?',
    tag: 'friendship',
    to: '#',
  },
  {
    title: 'Would you rather ride a bike, ride a horse, or drive a car?',
    tag: 'recreation',
    to: '#',
  },
  {
    title:
      'If you could hire someone to help you, would it be with cleaning, cooking, or yard work?',
    tag: 'historical events',
    to: '#',
  },
  {
    title: 'What is your favorite book to read?',
    tag: 'life advice',
    to: '#',
  },
  {
    title:
      'If you could only eat one meal for the rest of your life, what would it be?',
    tag: 'career advice',
    to: '#',
  },
  {
    title:
      'Which would you rather do: wash dishes, mow the lawn, clean the bathroom, or vacuum the house?',
    tag: 'unusual experiences',
    to: '#',
  },
  {
    title: 'Who is your hero?',
    tag: 'family',
    to: '#',
  },
  {
    title: 'What is your proudest accomplishment?',
    tag: 'career',
    to: '#',
  },
  {
    title: 'What would you change about yourself if you could?',
    tag: 'friendship',
    to: '#',
  },
  {
    title: 'Would you rather ride a bike, ride a horse, or drive a car?',
    tag: 'recreation',
    to: '#',
  },
  {
    title:
      'If you could hire someone to help you, would it be with cleaning, cooking, or yard work?',
    tag: 'historical events',
    to: '#',
  },
  {
    title: 'What is your favorite book to read?',
    tag: 'life advice',
    to: '#',
  },
  {
    title:
      'If you could only eat one meal for the rest of your life, what would it be?',
    tag: 'career advice',
    to: '#',
  },
  {
    title:
      'Which would you rather do: wash dishes, mow the lawn, clean the bathroom, or vacuum the house?',
    tag: 'unusual experiences',
    to: '#',
  },
  {
    title: 'Who is your hero?',
    tag: 'family',
    to: '#',
  },
  {
    title: 'What is your proudest accomplishment?',
    tag: 'career',
    to: '#',
  },
  {
    title: 'What would you change about yourself if you could?',
    tag: 'friendship',
    to: '#',
  },
  {
    title: 'Would you rather ride a bike, ride a horse, or drive a car?',
    tag: 'recreation',
    to: '#',
  },
  {
    title:
      'If you could hire someone to help you, would it be with cleaning, cooking, or yard work?',
    tag: 'historical events',
    to: '#',
  },
  {
    title: 'What is your favorite book to read?',
    tag: 'life advice',
    to: '#',
  },
  {
    title:
      'If you could only eat one meal for the rest of your life, what would it be?',
    tag: 'career advice',
    to: '#',
  },
];
export const MyMemories = [
  {
    title: 'My memory 1',
    body: 'Riding a hot air balloon has been on the top of my bucket list forever. I even wrote about it \
    in my 26 Things I want to do at 26 post earlier this year. And this past fall I got to cross off this incredi\
    ble experience with a long weekend glamping trip in the Willamette Valley with Travel Oregon and Oregon Wine \
    Country! I guess I should have assumed that the balloons take off right when they’re completely filled \
     and upright but we were not prepared to almost be left behind. We immediately sprinted to the balloon after \
     this group shot and climbed into the baskets for takeoff. We were the last members of the group and the other \
     passengers already claimed their corners of the basket. I knew that there was no propeller on hot air balloons\
      but I also didn’t understand how they navigated the winds. I learned from our hot air balloon pilot that the\
       balloons will climb and descend to catch specific wind directions. I was also surprised to learn that the\
        hot air balloon pilot will squirt a little shaving cream towards the ground to see which way the wind \
        is blowing beneath the balloon!',
    type: 'draft',
  },
  {
    title: 'My memory 2',
    body: 'Pigeons successfully learned to discriminate color slides of paintings by Monet and Picasso. F\
    ollowing this training, they discriminated novel paintings by Monet and Picasso that had never been presented\
     during the discrimination training. Furthermore, they showed generalization from Monet\'s to Cezanne\'s and \
     Renoir\'s paintings or from Picasso\'s to Braque\'s and Matisse\'s paintings. These results suggest\
      that pigeons\' behavior can be controlled by complex visual stimuli in ways that suggest categorization.\
       Upside-down images of Monet\'s paintings disrupted the discrimination, whereas inverted \
       images of Picasso\'s did not.This result may indicate that the pigeons\' behavior was controlled by\
        objects depicted in impressionists\' paintings but was not controlled by objects in cubists\' painting.',
    type: 'draft',
  },
  {
    title: 'My Memory 3',
    body: 'Contrary to many people’s beliefs, not all the planets on the solar system rotate around the s\
    un in an anti-clockwise pathway. It is however interesting to know that there is an exception. Venus is the o\
    nly planet that rotates around the sun in a clockwise pathway. All planets, when observed from the North Pole\
     are seen to be rotating around the sun in an anti-clockwise direction on their elliptical orbits. \
     Venus is observed to rotate in a clockwise manner. Below is a review of the planet Venus,\
      and the probable reasons as to why it does not rotate in the same direction as\
       the other planets in the Solar System.',
    type: 'draft',
  },
  {
    title: 'Scotland',
    body: 'With Scotland being famed for its love for and long history of myths and legends, it is no sur\
    prise that a fabled creature such as the unicorn is Scotland’s national animal. Unicorns have been linked to \
    Scotland for centuries. While the animal is mythological, the ideals it represents are what make it a perfect\
     fit as the national animal for Scotland, and because like this proud beast – Scots would fight to \
     remain unconquered.',
    type: 'draft',
  },
  {
    title: 'Avocados',
    body: 'Avocados are a fruit, not a vegetable. They\'re technically considered a single-seeded berry, \
    believe it or not. Avocados are believed to have originated around 10,000 years ago in the tropical climates \
    of Mexico, Guatemala, and the West Indies. Peak avocado season is late winter and early spring. Don’t toss th\
    e peels and pits. Instead, use them to make a natural dye. That’s right; avocado peels and pits can\
     be boiled to create a surprising and delicate pink hue. Re-use the avocado \
     pit to propagate them into house plants! They won’t produce fruit, but they will make \
     for some lovely greenery in your home. The most readily available variety of avocado is Hass, \
     also called avocado pear or alligator pear',
    type: 'published',
  },
  {
    title: 'Competitive art',
    body: 'Competitive art used to be an Olympic sport. Between 1912 and 1948, the international sporting\
     events awarded medals for music, painting, sculpture and architecture. Shame it didn\'t catch on, the famous\
      pottery scene in Ghost could have won an Olympic medal as well as an Academy Award for the best screenplay. \
      At the 1912 Summer Olympics in Stockholm, American Walter Winans took the podium and waved proudly \
      to the crowd. He had already won two Olympic medals—a gold for sharpshooting at the\
       1908 London Games, as well as a silver for the same event in 1912—but the gold he won at \
       Stockholm wasn’t for shooting, or running, or anything particularly athletic at all.\
        It was instead awarded for a small piece of bronze he had cast earlier that year: \
        a 20-inch-tall horse pulling a small chariot. For his work, An American Trotter,\
         Winans won the first ever Olympic gold medal for sculpture.',
    type: 'published',
  },
  {
    title: 'Summer Trip',
    body: 'If you’re looking for a short, but steep hiking trail with ocean views, I recommend checking o\
    ut the Lanikai Pillbox Trail. This trail is short, but it gets challenging because of how steep it is and how\
     crowded it gets. This trail is popular, so I recommend either visiting during the week or getting an early s\
     tart in the morning. If you’re looking for a spot for Hawaiian food, I recommend stopping by Highwa\
     y Inn. They have a few locations but my family on the island took me to the Ala Moana location.\
      The loco moco was so good!',
    type: 'published',
  },
  {
    title: 'Baking',
    body: 'The “German” part of German chocolate cake comes from an American man—not a European country. \
    Specifically, it’s named after Sam German, who in 1852 created the formula for a mild dark baking chocolate b\
    ar for Baker’s Chocolate Company, which was subsequently named Baker’s German’s Sweet Chocolate. Fast-forward\
     to June 13, 1957. The Dallas Morning Star published the recipe for the cake, invented and submitte\
     d by a reader identified as Mrs. George Clay, according to What’s Cooking America.',
    type: 'published',
  },
  {
    title:
      'Is it your goal to take your side-hustle full-time in 2022? \
      Or is it your goal to start thinking about this as a possibility?',
    body: null,
    type: 'mindpop',
  },
  {
    title:
      'A chef\'s hat has 100 pleats. Apparently, it\'s meant to represent the 100 ways you can cook an egg. ',
    body: null,
    type: 'mindpop',
  },
  {
    title: 'Baby rabbits are called kits.',
    body: null,
    type: 'mindpop',
  },
  {
    title: 'Write about your birthday this year',
    body: null,
    type: 'mindpop',
  },
];
export const notifications = [
  {
    sender: {
      name: 'My Stories Matter',
      picture: 'msm-notif-logo',
    },
    time: 1652252400000,
    description: 'Your friend who you referred just wrote their first memory!',
    cta: {
      title: 'View memory',
      to: '/memory/blah',
    },
    image:
      'https://images.unsplash.com/photo-1505118380757-91f5f5632de0?ixlib=rb-1.2.1\
      &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=926&q=80',
    read: false,
  },

  {
    sender: {
      name: 'My Stories Matter',
      picture: 'msm-notif-logo',
    },
    time: 1651993200000,
    description:
      'We\'re excited for you to experience My Stories Matter! Before the fun can begin, \
      please check your inbox to verify your email address.',
    cta: {
      title: null,
      to: null,
    },
    image: null,
    read: false,
  },

  {
    sender: {
      name: 'Jordan Wright',
      picture:
        'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1\
        &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80',
    },
    time: 1651561200000,
    description: 'Liked your memory \'Dinner with friends\'',
    cta: {
      title: 'View memory',
      to: '/memory/blah',
    },
    image:
      'https://images.unsplash.com/photo-1651981090786-238f2f57af74?ixlib=rb-1.2.1\
      &ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1041&q=80',
    read: true,
  },

  {
    sender: {
      name: 'My Stories Matter',
      picture: 'msm-notif-logo',
    },
    time: 1651388400000,
    description:
      'We think you\'ll love this Prompt of the Week: Who do you look up to?',
    cta: {
      title: 'Answer prompt',
      to: null,
    },
    image: null,
    read: true,
  },

  {
    sender: {
      name: 'My Stories Matter',
      picture: 'msm-notif-logo',
    },
    time: 1651302000000,
    description:
      'Your friend who you referred just joined My Stories Matter! Check out their profile.',
    cta: {
      title: 'View profile',
      to: null,
    },
    image: null,
    read: true,
  },
];
// eslint-disable-next-line max-len
export const Expanded_Memory_Data = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Amet, vitae nunc et lacus fringilla. Tincidunt nibh nec sit mi nunc. Nunc mattis amet ultrices cras id lacus ac. Purus est velit placerat gravida lectus tincidunt platea ac venenatis. Ac sit suspendisse morbi aliquet in aenean vestibulum leo felis. Diam libero laoreet gravida nibh. Laoreet pretium tortor tristique quis enim vel arcu. Auctor fames dignissim hendrerit volutpat, sociis lectus vel. Convallis fames aliquam arcu, nulla a morbi. Facilisis facilisis justo, suscipit semper tincidunt. Vivamus tellus aliquet purus risus purus aliquam ac. Phasellus est sit ac convallis sed. Id ipsum ullamcorper at rutrum maecenas vel nibh suspendisse cursus. Urna eleifend enim donec aliquam dui auctor tempor tellus id. Tortor augue etiam sit gravida turpis. Vitae cursus ante tempor, bibendum nisl, cras potenti nibh et. A felis id in cursus quis malesuada orci cras sit. Malesuada morbi platea et lacus. Quam at mauris pharetra aliquam cursus. Odio quis elementum in cras massa. In eget integer aliquet vivamus duis. Pretium fames consectetur mauris vel quam ultrices in leo. Bibendum neque, ut volutpat, lobortis eu. Felis, pharetra sed aliquam diam. Ut cursus in pharetra scelerisque. Nisi risus metus, amet, amet urna pulvinar eget eu. Erat vitae in ut viverra tincidunt nisl volutpat. Tincidunt eu, molestie lectus id rhoncus sit massa aenean. Massa venenatis egestas vulputate at commodo elementum quisque ultrices. Mollis sem risus faucibus pulvinar sit porttitor dolor at. Faucibus commodo interdum lorem nisl cras. Adipiscing molestie dui penatibus nulla. Turpis tristique aliquam ullamcorper enim tristique in ultricies volutpat nisi. Porttitor mus est morbi sollicitudin pretium donec in sed. Urna sit a, faucibus tellus, id sit sed arcu diam. Ultrices lobortis blandit tellus augue enim proin. Aliquet vitae viverra dolor at magna tristique. Et convallis ut pulvinar curabitur tortor. Scelerisque viverra etiam eleifend morbi mi aliquet hac consequat aliquam. Eget sit ornare tristique ut porta arcu. Odio amet mattis metus venenatis, consequat bibendum pharetra condimentum. Ultricies pretium scelerisque elit donec velit, laoreet ultrices scelerisque. Duis tortor, cursus facilisi massa tellus praesent. Senectus semper malesuada hac in. Faucibus condimentum scelerisque at risus eu justo. Fermentum eu in in proin morbi lectus lectus at luctus. Auctor a tristique malesuada platea proin lobortis nisl. Cras eget tellus a pellentesque sociis ante ultrices magna. Nibh at amet, praesent faucibus nibh id purus suspendisse ut. Etiam enim in mattis sollicitudin. Amet tellus cursus sollicitudin egestas pulvinar tellus leo pulvinar. Et lacus, pellentesque arcu, eu. Mi in sit urna turpis. Tellus et, bibendum et a accumsan nulla tellus quam convallis. Mattis tellus rhoncus, at morbi quis sit. Facilisi phasellus nunc egestas vitae dolor sit diam in est. Nunc tortor vitae quam sit est blandit sapien duis tincidunt. Vitae amet dolor fermentum, massa. Eleifend ornare erat egestas amet volutpat suspendisse nullam at nibh. Tellus massa eleifend purus sagittis tristique viverra. Amet id molestie ipsum ac sagittis eros nec. Etiam quam neque dolor, massa quisque. Morbi id congue egestas condimentum ac. Aliquet sagittis pulvinar praesent viverra ultricies sapien. Enim in id tellus porttitor. Ipsum eget facilisis lorem urna, platea consequat. Fusce sapien, sed pharetra feugiat massa mi. Metus eleifend nisl volutpat euismod. Massa laoreet nisl lorem felis, cursus in. Pretium diam urna ullamcorper egestas. Facilisis hendrerit tempus ut nec nibh. Dictumst morbi nulla praesent arcu in sed. Integer cursus gravida lorem lacus, odio sit elementum gravida. Lectus mi faucibus in nulla turpis ultricies rutrum. Nascetur in duis sed ligula ultricies lectus nec. Ut aliquam dignissim egestas in nisl nunc volutpat. Varius donec pellentesque vel faucibus maecenas a ligula. Sit in sollicitudin eget at egestas massa. Lectus aenean in dolor, eget cras duis sed vivamus. Phasellus ultrices pellentesque ac amet diam. Enim arcu tempus blandit aliquet donec eget praesent. Pretium ultrices odio sed nulla diam imperdiet lorem. Euismod urna, in sagittis, non eget facilisis tempor. Aliquet cursus et vel ipsum viverra. Consectetur venenatis, id lorem massa donec vulputate. Tempus, sit ac eget lectus arcu ornare. Arcu ornare sodales vitae justo a eu. Pellentesque porttitor malesuada sit vitae eu. Sed nec vitae imperdiet ac adipiscing quis scelerisque molestie. Sed adipiscing porta donec eget euismod lectus imperdiet id fames. Sollicitudin ut aenean arcu pellentesque sit nullam. Pretium nullam diam sociis nisl velit. Mattis lectus amet magna viverra convallis magna interdum ut. Vitae dignissim purus velit urna ipsum diam sed quisque id. Vestibulum massa quis nibh sed sit elit. Amet sed hendrerit porta sed molestie ut. Turpis molestie donec consequat diam lacus viverra iaculis nullam neque. Dui scelerisque nullam sed sed scelerisque nunc proin dictum adipiscing. Nibh blandit facilisis sed tellus pulvinar volutpat. Phasellus elit eros, nisl tellus maecenas morbi. Ut eget varius pretium commodo. Non nec in tellus, enim, odio. Blandit et, bibendum egestas vitae fermentum facilisi nisi'

export const dataWithoutHtml = 'Thanks for joining My Stories Matter (MSM)! We’re excited for you to begin exploring our journaling app that helps you recall and record your memories. Through our website, you have the ability to write openly, organize your thoughts, and connect with yourself.But what’s a memory? We like to say "a memory is what you make it to be." My Stories Matter is personalized and customizable to you and your needs. Whether it’s a daily journal entry, a life story, a poem - a "memory" is yours to craft.Besides writing new memories, you’ll likely find yourself on these main pages as you begin exploring the app:Recent: Find memories in order by the date you published them, where most recent is at the top.Memory Editor: Our “less is more” approach places focus on your writing with a larger editor area and streamlined design. Edit: Find your in-progress work on this page and continue crafting and preparing to publish!We hope you enjoy My Stories Matter!Happy Reminiscing,The My Stories Matter TeamBut what’s a memory? We like to say "a memory is what you make it," as My Stories Matter is personalized and customizable to you and your needs. Whether it’s a daily journal entry, a life story, a poem - a "memory" is yours to craft.Besides writing new memories, you’ll likely find yourself on these main pages as you begin using the app:Recent: Find memories in order by date you publish them, where most recent is at the top.Prompts: Explore new ideas to write about with these prompted questions.Edit: Find your in-progress work here to continue crafting and preparing to publish!We hope you enjoy My Stories Matter!Happy Reminiscing,The My Stories Matter Team'
export const introductoryData = '<p>Thanks for joining My Stories Matter (MSM)! We’re excited for you to begin exploring our journaling app that helps you recall and record your memories. Through our website, you have the ability to write openly, organize your thoughts, and connect with yourself.</p><br/><p>But what’s a memory? We like to say "a memory is what you make it to be." My Stories Matter is personalized and customizable to you and your needs. Whether it’s a daily journal entry, a life story, a poem - a "memory" is yours to craft.</p><br/><p>Besides writing new memories, you’ll likely find yourself on these main pages as you begin exploring the app:</p> <br/><ul style="margin-left:30px;list-style-type:disc;"><li><strong>Recent:</strong> Find memories in order by the date you published them, where most recent is at the top.</li><li><strong>Memory Editor</strong>: Our “less is more” approach places focus on your writing with a larger editor area and streamlined design. </li><li><strong>Edit</strong>: Find your in-progress work on this page and continue crafting and preparing to publish!</li></ul><br/><p>We hope you enjoy My Stories Matter!</p><br/><p>Happy Reminiscing,<br/>The My Stories Matter Team</p>';